<div
  [formGroup]="passwordFormGroup"
  class="form-group form-success-highlight form-error-highlight"
  [class.form-error-highlight]="showErrors">
  <label for="password" class="label">{{ label | translate }}*</label>
  <input type="password" class="form-control" id="password" formControlName="password" />
  <div class="mt-2 animated fadeIn">
    <span
      class="colorize text"
      [class.green]="
        !(
          passwordFormGroup.controls.password.errors &&
          (passwordFormGroup.controls.password.errors['required'] ||
            passwordFormGroup.controls.password.errors['minlength'])
        )
      "
      [class.warning]="
        showErrors &&
        passwordFormGroup.controls.password.errors &&
        (passwordFormGroup.controls.password.errors['required'] ||
          passwordFormGroup.controls.password.errors['minlength'])
      ">
      @if (
        !(
          passwordFormGroup.controls.password.errors &&
          (passwordFormGroup.controls.password.errors['required'] ||
            passwordFormGroup.controls.password.errors['minlength'])
        )
      ) {
        <i class="fa fa-check me-2"></i>
      }
      <strong
        [innerHtml]="
          'password.errors.min_password_length'
            | translate: { minLength: 8, actualLength: passwordFormGroup.controls.password.value.length }
        "></strong
      ><br />
    </span>
    <span
      class="colorize text"
      [class.green]="
        !(passwordFormGroup.controls.password.errors && passwordFormGroup.controls.password.errors['strongPassword'])
      "
      [class.warning]="
        showErrors &&
        passwordFormGroup.controls.password.errors &&
        passwordFormGroup.controls.password.errors['strongPassword']
      ">
      @if (
        !(passwordFormGroup.controls.password.errors && passwordFormGroup.controls.password.errors['strongPassword'])
      ) {
        <i class="fa fa-check me-2"></i>
      }
      <strong
        [innerHtml]="
          'password.errors.strong_password'
            | translate
              : {
                  minRequirementsMet: passwordStrength?.minRequirementsMet,
                  requirementsMet: passwordStrength?.requirementsMet,
                }
        "></strong>
    </span>
    <div class="mb-1">
      <ul class="mb-0 small">
        @for (passwordValidator of passwordValidators; track passwordValidator) {
          <li>
            <span
              >{{ 'password_requirement.' + passwordValidator | translate }}
              @if (passwordStrength && passwordStrength.requirements[passwordValidator].value === true) {
                <i class="fa fa-check colorize text green"></i>
              }
            </span>
          </li>
        }
      </ul>
    </div>

    @if (passwordFormGroup.controls['password'].value.length > 0) {
      <span class="small text-uppercase">{{ 'password.password_strength' | translate }}</span>
      <div class="progress">
        <div
          class="progress-bar w-100"
          role="progressbar"
          [class.bg-danger]="passwordStrength.requirementsMet <= 1"
          [class.bg-warning]="
            passwordStrength?.requirementsMet < passwordStrength?.minRequirementsMet &&
            passwordStrength?.requirementsMet !== 0
          "
          [class.bg-success]="passwordStrength?.requirementsMet >= passwordStrength?.minRequirementsMet"
          [attr.aria-valuenow]="passwordStrength?.requirementsMet"
          aria-valuemin="0"
          [attr.aria-valuemax]="passwordStrength?.minRequirementsMet"></div>
      </div>
    }
  </div>
</div>
